import { TReportType } from 'contexts/app-context/types'
import Data from 'common/api'
import { PostReportRequest, TSetPurposeUS } from 'common/types'

const PATH = '/privacy-center/v1/'

const endpointSetter = (endpoint: string, path?: string) => `${path ?? PATH}${endpoint}`

export const base: Data = {
  action: 'requestAPI',
  evtId: '',
  metadata: {
    endpoint: '',
    headers: {
      'x-inter-lgpd-origem': 'US',
    },
    method: '',
    engine: 'CA',
  },
}

export const updateReportStatusUS = (type: TReportType) => ({
  ...base,
  metadata: {
    ...base.metadata,
    endpoint: endpointSetter('request-data'),
    method: 'PUT',
    headers: {
      ...base.metadata.headers,
      'x-inter-request-type': type,
    },
    body: {},
  },
})

export const getPreferences = {
  ...base,
  metadata: {
    ...base.metadata,
    endpoint: endpointSetter('preferences/purposes'),
    method: 'GET',
  },
}

export const updatePreferencesUs = ({
  body,
  productId,
  userAccountType,
  userCountry,
  userSelectedEntity,
  headers,
}: TSetPurposeUS) => ({
  ...base,
  metadata: {
    ...base.metadata,
    headers: { ...base.metadata.headers, ...headers },
    endpoint: endpointSetter(
      `/preferences/${userCountry}/${userAccountType}/${userSelectedEntity}/${productId}`,
      '/app-pf/privacy-center-preferences/v1',
    ),
    method: 'PUT',
    body,
  },
})

export const getReportViaEmailUS = (reportRequest: PostReportRequest) => ({
  ...base,
  metadata: {
    ...base.metadata,
    endpoint: endpointSetter('request-data/send-report-email'),
    method: 'POST',
    body: reportRequest,
  },
})
